<div class="container tagsDrawerWrapper">
  <div class="DrawerHeader">
    <ng-template #createTag>
      <h2>{{ trans.CreateTag | translate }}</h2>
    </ng-template>

    <h2 *ngIf="data?.name; else createTag">  {{ trans.Tag | translate }}: {{ data?.name }}</h2>

    <div class="header-controls">
      <ng-container *ngIf="isComponentPage || selectedTagType?.name === 'Calculated'">
        <!-- save and add new button -->
        <button *ngIf="!dataService.getTagsEditMode()"
          [disabled]="formGroupTags.invalid || !isEdited || (isCalculatedTag && (!calculatedExecuted || !isCalRetrunTypeValid))"
          class="btn-icons" type="button"
          [ngClass]="{'disabled': (formGroupTags.invalid || !isEdited) || (isCalculatedTag && (!calculatedExecuted || !isCalRetrunTypeValid))}"
          (click)="save()">
          <mat-icon [customTooltip]="getValidationsTooltip(true)">plus_one</mat-icon>
        </button>

        <!-- save and close button -->
        <button
          [disabled]="formGroupTags.invalid || !isEdited || (isCalculatedTag && (!calculatedExecuted || !isCalRetrunTypeValid))"
          [ngClass]="{'disabled': (formGroupTags.invalid || !isEdited) || (isCalculatedTag && (!calculatedExecuted || !isCalRetrunTypeValid))}"
          class="btn-icons" type="button" (click)="save(true)">
          <mat-icon [customTooltip]="getValidationsTooltip()">check</mat-icon>
        </button>

      </ng-container>
      <button class="btn-icons" type="button" customTooltip="{{ trans.Close }}" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="drawerBody">
    <mat-tab-group class="matTabsTags">
      <mat-tab label="{{ trans.Details }}">
        <form [formGroup]="formGroupTags" class="formDetils">
          <div style="flex-direction: column !important;">
            <div fxFlex="row" fxLayoutAlign="space-between start">
              <div fxFlex="38">
                <mat-form-field appearance="outline">
                  <mat-label>  {{ trans.Name | translate }}</mat-label>
                  <input type="text" matInput formControlName="name" [matAutocomplete]="auto" appAutoFocus required
                    (input)="onNameInput($event.target.value)" pattern="^[a-zA-Z]([a-zA-Z0-9_/-\s_.])+$" maxlength="40" />
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onNameInput($event.option.value)">
                    <mat-option *ngFor="let filteredTagName of filteredTagNames | async" [value]="filteredTagName.name">
                      {{ filteredTagName.name }}
                    </mat-option>
                  </mat-autocomplete>

                  <mat-error *ngIf="formGroupTags.get('name').errors?.duplicate" class="m-t-15">
                   {{ trans.NameAlreadyExists | translate }}
                  </mat-error>

                </mat-form-field>

                <mat-form-field appearance="outline" class="m-t-5">
                  <mat-label>{{ trans.Description | translate }}</mat-label>
                  <input matInput formControlName="description" autocomplete="none" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{ trans.DisplayName | translate }}</mat-label>
                  <input matInput required formControlName="displayName" (input)="onDisplayNameInput($event.target.value)" autocomplete="off"
                    pattern="^[a-zA-Z]([a-zA-Z0-9_/-\s_.])+$" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="m-b-15">
                  <mat-label>{{ trans.TagType | translate }}</mat-label>
                  <mat-select [disabled]="data?.id" formControlName="tagTypeId" (selectionChange)="onTagTypeChanged()">
                    <mat-option *ngFor="let tagType of tagTypes" [value]="tagType.id"
                      [disabled]="disableCalculatedType && tagType.name === tagDataTypes.Calculated">
                      {{ tagType.name| translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <section *ngIf="isCalculatedTag">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ trans.ReturnType | translate }}</mat-label>
                    <mat-select matNativeControl formControlName="returnType"
                      (selectionChange)="onReturnTypeChanged($event.value)" required>
                      <mat-option *ngFor="let returnType of returnTypes" [value]="returnType.value"> {{ returnType.name
                        }} </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- <div *ngIf="isCalculatedTag && formGroupTags.get('returnType')?.value === calReturnTypes.Numeric">
                    <div class="percision-container">
                      <div fxLayout="row" fxLayoutAlign="space-between none">
                        <mat-form-field appearance="outline" fxFlex="45">
                          <mat-label>Reject Min</mat-label>
                          <input matInput type="number" required formControlName="rejectMin" autocomplete="off" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" fxFlex="45">
                          <mat-label>Reject Max</mat-label>
                          <input matInput type="number" required formControlName="rejectMax" autocomplete="off" />
                        </mat-form-field>
                      </div>

                      <div class="percisionBlok" fxLayoutAlign="space-between none">
                        <mat-form-field appearance="outline" fxFlex="20">
                          <mat-label>Decimal Places</mat-label>
                          <input matInput required type="number" formControlName="precision" autocomplete="off"
                            (change)="onDecimalChange()" />
                        </mat-form-field>
                        <mat-form-field appearance="outline" fxFlex="40">
                          <mat-label>Sample</mat-label>
                          <input matInput formControlName="precisionSample" autocomplete="off" />
                        </mat-form-field>

                        <div class="seperator" fxFlex="35">
                          <mat-checkbox class="usethousand m-b-10" color="accent" formControlName="isThousandSeparator"
                            (change)="formatNumberField($event.checked)">
                            1000 Separator
                          </mat-checkbox>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </section>

                <div class="allowWriteContainer" *ngIf="showAllowWrites">
                  <mat-checkbox (change)="onAllowWriteChanged($event)" color="primary" formControlName="allowWrite">
                    Allow Writes
                  </mat-checkbox>
                </div>
                <div style="height: 75px" fxLayout="row" fxLayoutAlign="space-between end">
                  <div fxFlex="60">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ trans.Historize | translate }}</mat-label>
                      <mat-select matNativeControl #historizeSelect formControlName="historizedId"
                        (change)="onHistorizeChanged(historizeSelect.value)">
                        <mat-option *ngFor="let historizeType of historizeTypes" [value]="historizeType.id">
                          {{ historizeType.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <ng-container *ngIf="selectedTagType?.name == 'Number'">
                    <div fxFlex="15" class="percent-range" *ngIf="isOnChange(historizeSelect.value)">
                      <div fxLayout="row" fxLayoutAlign="space-between stretch">
                        <span fxFlexAlign="flex-end"
                          style="font-size: 1.2em; line-height: 2.8em; width: 100%; text-align: center;">&#177;</span>
                      </div>
                    </div>
                    <div fxFlex="25" *ngIf="isOnChange(historizeSelect.value)">
                      <div fxLayout="row" fxLayoutAlign="space-between stretch">
                        <mat-form-field class="HistorizeValueHolder" appearance="outline">
                          <mat-label>%</mat-label>
                          <input matNativeControl type="number" id="value" formControlName="histPercentChange"
                            class="inputHistorizeValue" max="100" min="0" autocomplete="off" />
                        </mat-form-field>

                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div fxFlex="2" class="divider"></div>

              <div fxFlex="54">
                <!-- Calculated tags section -->
                <app-calculate-tag *ngIf="selectedTagType?.name === 'Calculated'" [allTags]="allTags"
                  [allModelTags]="allModelTags" [calTagDetail]="viewCalTagDetail" [formGroupTags]="formGroupTags"
                  [selectedTagType]="selectedTagType" (calculatedTagDetail)="calculatedTagDetail($event)">
                </app-calculate-tag>

                <div class="numberSelect" *ngIf="selectedTagType?.name == 'Number'">
                  <div class="">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ trans.MeasurementCategory | translate }}</mat-label>
                      <input type="text" matInput formControlName="measurementCategory"
                        [matAutocomplete]="auto" (input)="onMeasurementInput($event.target.value)" />
                      <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="onMeasurementSelection($event.option.value)">
                        <mat-option *ngFor=" let option of measurementCategories | async" [value]="option.name">
                          {{ option.name }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>

                    <div fxLayout="row" fxLayoutAlign="space-between none">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ trans.DisplayUOM | translate }}</mat-label>
                        <input type="text" matInput formControlName="displayEuId" [matAutocomplete]="autoeu" readonly/>
                        <mat-autocomplete autoActiveFirstOption #autoeu="matAutocomplete"
                          (optionSelected)="onDisplayEuSelection($event.option)">
                          <mat-option *ngFor="let optionEu of filteredOptionsdisplayEU | async" [value]="optionEu.name">
                            {{ optionEu.name }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                  </div>

                  <div fxLayout="row" fxLayoutAlign="space-between none">
                    <mat-form-field appearance="outline" fxFlex="45">
                      <mat-label> {{ trans.RejectMin | translate }}</mat-label>
                      <input matInput type="number" required formControlName="rejectMin" autocomplete="off" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="45">
                      <mat-label> {{ trans.RejectMax | translate }}</mat-label>
                      <input matInput type="number" required formControlName="rejectMax" autocomplete="off" />
                    </mat-form-field>
                  </div>
                  <!-- <div fxLayout="row" fxLayoutAlign="space-between none">
                    <mat-form-field appearance="outline" class="factor" fxFlex="45">
                      <mat-label>Factor</mat-label>
                      <input matInput required type="number" formControlName="factor" autocomplete="off" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="offset" fxFlex="45">
                      <mat-label>Offset</mat-label>
                      <input matInput required type="number" formControlName="offset" autocomplete="off" />
                    </mat-form-field>
                  </div> -->

                  <div class="percisionBlok" fxLayoutAlign="space-between none">
                    <mat-form-field appearance="outline" fxFlex="20">
                      <mat-label>{{ trans.DecimalPlaces | translate }}</mat-label>
                      <input matInput required type="number" formControlName="precision" autocomplete="off"
                        (change)="onDecimalChange()" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="40">
                      <mat-label> {{ trans.Sample | translate }}</mat-label>
                      <input matInput formControlName="precisionSample" autocomplete="off" />
                    </mat-form-field>

                    <div class="seperator" fxFlex="35">
                      <mat-checkbox class="usethousand m-b-10" color="primary" formControlName="isThousandSeparator"
                        (change)="formatNumberField($event.checked)">
                        1000  {{ trans.Separator | translate }}
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
                <app-state-form *ngIf="selectedTagType?.name == 'State'" [states]="stateList"
                  [isComponentPage]="isComponentPage" (addNewState)="addState($event)"
                  (removeSelectedState)="removeState($event)">
                </app-state-form>
              </div>

            </div>
          </div>
        </form>
      </mat-tab>
      <mat-tab  label="{{ trans.Permissions }}"></mat-tab>
      <mat-tab label="{{ trans.Visibility }}" ></mat-tab>
    </mat-tab-group>
  </div>
</div>